import {useEffect, useState} from "react";

function useDelayUnmount(
  isMounted: boolean,
  delayTime: number,
  setIsMounted?: React.Dispatch<React.SetStateAction<boolean>>
) {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let timeoutId: any;
    if (isMounted && !shouldRender) {
      setIsMounted && setIsMounted(true);
      setShouldRender(true);
    } else if (!isMounted && shouldRender) {
      timeoutId = setTimeout(() => setShouldRender(false), delayTime);
    }
    return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, shouldRender]);
  return shouldRender;
}

export default useDelayUnmount;
